<template>
  <div>

    <el-row :gutter="20">
      <el-form :inline="true"
               :model="reportPageInfo"
               class="demo-form-inline">
        <el-form-item label="用户"
                      label-width="70px">
          <el-input v-model="keyword"
                    clearable
                    placeholder="手机号/真实姓名/用户"></el-input>
        </el-form-item>
        <el-form-item label="报告类型"
                      label-width="70px">
          <el-select v-model="reportPageInfo.reportType"
                     clearable
                     placeholder="报告类型">
            <el-option label="所有"
                       value="ALL" />
            <el-option label="个股报告"
                       value="SIMPLE" />
            <el-option label="财务报告"
                       value="FINANCE" />
            <el-option label="个股简报"
                       value="TINY" />
            <el-option label="概念报告"
                       value="CONCEPT" />
            <el-option label="组合报告"
                       value="COMPARE" />
            <el-option label="港股报告"
                       value="HKSTOCK" />
          </el-select>
        </el-form-item>
        <el-form-item label="生成时间">
          <el-date-picker v-model="dateRange"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="getReportList()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row>

          <el-table v-loading="tableLoading"
                    :data="reportPageInfo.records"
                    style="width: 100%">
            <el-table-column label="用户">
              <template slot-scope="scope">
                {{scope.row.username}}{{scope.row.orgUserStatus==='DELETED'?'(失效)':''}}
              </template>
            </el-table-column>
            <el-table-column prop="names"
                             label="报告名称">
            </el-table-column>

            <el-table-column label="报告类型">
              <template slot-scope="scope">
                {{scope.row.reportType | reportTypeFilter}}
              </template>

            </el-table-column>
            <el-table-column prop="createTime"
                             label="创建时间"
                             width="150">
            </el-table-column>
            <el-table-column label="报告状态">
              <template slot-scope="scope">
                {{scope.row.status | statusFilter}}
              </template>
            </el-table-column>
            <el-table-column label="文件类型">
              <template slot-scope="scope">
                {{scope.row.fileType | fileTypeFilter}}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">

                <el-button type="text"
                           :disabled="scope.row.fileType==='DOC'"
                           @click="toRead(scope.row.sourceId)"
                           size="small">阅读</el-button>
                <el-button type="text"
                           @click="toDownload(scope.row.sourceId)"
                           size="small">下载</el-button>

              </template>

            </el-table-column>
          </el-table>

        </el-row>
        <el-row>
          <br>
          <el-pagination background
                         @current-change="getReportList"
                         layout="prev, pager, next,total"
                         :current-page="reportPageInfo.current"
                         :page-size="reportPageInfo.size"
                         :total="reportPageInfo.total">
          </el-pagination>

        </el-row>
      </el-col>

    </el-row>
    <el-dialog width="500"
               top="0"
               :close-on-click-modal=false
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl+'#toolbar=0'"
              title=""
              style="width: 100%;
    height: calc(100vh - 120px);
    border: 0;" />
      <br>
      <div style="text-align:center">
        <el-button @click="toDownload(curReport)"
                   size="small">下载</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>

import axios from 'axios'
import moment from 'moment'
export default {
  name: 'myReports',
  props: ['username'],
  data: function () {
    return {
      pdfDialogVisible: false,
      tableLoading: true,
      keyword: '',
      pdfUrl: '',
      reportPageInfo: {
        keyword: '',
        reportType: 'ALL',

        total: 0
      },
      dateRange: [],
      userPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      }

    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    statusFilter: function (v) {
      switch (v) {
        case 'FINISH':
          return '已完成'
        case 'FAIL':
          return '生成失败'
        case 'DOING':
          return '生成中'
        default:
          return v
      }
    },
    typeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '股票'
        case 'CONCEPT':
          return '概念'
      }
    },
    reportTypeFilter: function (v) {
      switch (v) {
        case 'ALL':
          return '所有'
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'COMPARE':
          return '投资组合'
        case 'HKSTOCK':
          return '港股报告'
        case 'FINANCE':
          return '财务报告'
        default:
          break
      }
      return v
    },

    fileTypeFilter: function (v) {
      switch (v) {
        case 'PDF':
          return 'PDF'
        case 'DOC':
          return 'WORD'
        case 'ALL':
          return '所有'

        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    }
  },
  methods: {

    getReportList () {
      let _this = this
      let startTime = (this.dateRange && this.dateRange[0]) || ''
      let endTime = (this.dateRange && this.dateRange[1]) || ''
      if (startTime) {
        startTime = moment(startTime).format('YYYY-MM-DD')
      }
      if (endTime) {
        endTime = moment(endTime).format('YYYY-MM-DD')
      }
      axios.get(`/api/web/csmarUser/getorgReportlist?page=${this.reportPageInfo.page || '1'}&pageSize= ${this.reportPageInfo.pageSize || '10'}&keyword=${this.keyword}&reportType=${this.reportPageInfo.reportType}&startTime=${startTime}&endTime=${endTime}`).then(resp => {
        _this.reportPageInfo.total = parseInt(resp.data.total)
        _this.reportPageInfo.records = resp.data.data
        _this.tableLoading = false
      })
    },

    toRead (sourceId) {
      this.sourceId = sourceId
      this.pdfUrl = '/api/web/stock/readPdf/' + sourceId
      this.pdfDialogVisible = true
    },
    toDownload (sourceId) {
      window.open('/api/web/stock/downLoadReport/' + sourceId)
    }
  },
  components: {

  },
  mounted () {
    this.getReportList()
  },
  computed: {
    orgId: function () {
      return this.$store.state.orgId
    }
  },
  watch: {
    orgId: function () {
      console.log('切换了orgId---report' + this.orgId)
      this.getReportList()
    },
    username: function () {
      this.keyword = this.username
      this.reportPageInfo.page = 1
      this.getReportList()
    }
  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/biz/report.vue